import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './core/http.service';
import { Observable } from 'rxjs';
import { ErisProcessesInfo } from '../models/services/admin/erisProcessesInfo';
import { ErisProcessQueueInfo } from '../models/services/admin/erisProcessQueueInfo';
import { ErisManualProcessInfo } from '../models/services/admin/erisManualProcessInfo';
import { PublicisAudience } from '../models/services/admin/dataTransferInfo';
import { Trace } from '../models/services/admin/trace';
import { Audience, Transfer } from '../models/services/audience';

@Injectable({
  providedIn: 'root'
})
export class MonitorService {

  constructor(
    private httpService: HttpService
  ) { }

  public getAllProcesses(): Observable<ErisProcessesInfo> {
    let url: string = `${environment.adminServicesApiBaseUri}/processes`;
    return this.httpService.get(url, undefined, true);
  }  

  public getProcessDetail(id: string): Observable<Trace[]> {
    let url: string = `${environment.adminServicesApiBaseUri}/processes/${id}`;
    return this.httpService.get(url, undefined);
  }    

  public getIngestionProcessesInfo(): Observable<ErisProcessQueueInfo[]> {
    let url: string = `${environment.adminServicesApiBaseUri}/ingestionProcesses`;
    return this.httpService.get(url, undefined, true);
  }  

  public getManualProcessesInfo(): Observable<ErisManualProcessInfo[]> {
    let url: string = `${environment.adminServicesApiBaseUri}/manualProcesses`;
    return this.httpService.get(url, undefined, true);
  }

  public getRunningAndFailedAudiences(): Observable<Audience[]> {
    let url: string = `${environment.adminServicesApiBaseUri}/audiences/runningAndFailed`;
    return this.httpService.get(url, undefined, true);
  }

  public getRunningAndFailedTransfers(): Observable<Transfer[]> {
    let url: string = `${environment.adminServicesApiBaseUri}/audiences/all/transfers/runningAndFailed`;
    return this.httpService.get(url, undefined, true);
  }

  public isOptimizationEnabled(): Observable<boolean> {
    let url: string = `${environment.adminServicesApiBaseUri}/ingestionProcesses/optimization/enabled`;
    return this.httpService.get(url, undefined);
  }

  public enableOptimization(): Observable<void> {
    let url: string = `${environment.adminServicesApiBaseUri}/ingestionProcesses/optimization/enable`;
    return this.httpService.postNoResponse(url, undefined);
  }

  public disableOptimization(): Observable<void> {
    let url: string = `${environment.adminServicesApiBaseUri}/ingestionProcesses/optimization/disable`;
    return this.httpService.postNoResponse(url, undefined);
  }
  
  public enableProcessOptimization(processId: number): Observable<void> {
    let url: string = `${environment.adminServicesApiBaseUri}/ingestionProcesses/${processId}/optimization/enable`;
    return this.httpService.postNoResponse(url, undefined);
  }

  public disableProcessOptimization(processId: number): Observable<void> {
    let url: string = `${environment.adminServicesApiBaseUri}/ingestionProcesses/${processId}/optimization/disable`;
    return this.httpService.postNoResponse(url, undefined);
  } 

  public markProcessAsIdle(operationId: string): Observable<void> {
    let url: string = `${environment.adminServicesApiBaseUri}/processes/${operationId}/mark-as-idle`;
    return this.httpService.postNoResponse(url, undefined);
  } 

  public relaunchAutomatedRefreshProcess(operationId: string): Observable<void> {
    let url: string = `${environment.adminServicesApiBaseUri}/processes/${operationId}/relaunch-automated-refresh`;
    return this.httpService.postNoResponse(url, undefined);
  } 
}
